import React from "react";
import { Skeleton, Card, Divider } from "antd";

const SkeletonLoader = () => {
  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f6f8fa",
        minHeight: "100vh",
      }}
    >
      {/* Title Placeholder */}
      <Skeleton.Input
        active
        style={{ width: "300px", height: "32px", marginBottom: "20px" }}
      />

      {/* Tabs Placeholder */}
      <Skeleton.Button
        active
        style={{ width: "100%", height: "40px", marginBottom: "20px" }}
      />

      <div style={{ display: "flex", gap: "20px" }}>
        {/* User-Friendly Keys Section */}
        <Card
          style={{
            width: "20%",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            maxHeight: "500px",
            overflowY: "auto",
          }}
        >
          <Skeleton.Input
            active
            style={{
              width: "180px",
              height: "24px",
              marginBottom: "10px",
            }}
          />
          <Skeleton
            active
            paragraph={{
              rows: 6,
              width: ["100%", "90%", "80%", "70%", "60%", "50%"],
            }}
          />
        </Card>

        {/* Mapped Keys Section */}
        <Card
          style={{
            flex: 1,
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            maxHeight: "500px",
            overflowY: "auto",
          }}
        >
          <Skeleton.Input
            active
            style={{
              width: "240px",
              height: "24px",
              marginBottom: "10px",
            }}
          />
          <Skeleton
            active
            paragraph={{
              rows: 10,
              width: ["100%", "95%", "90%", "85%", "80%", "75%", "70%", "65%", "60%", "55%"],
            }}
          />
        </Card>

        {/* Unmapped Keys Section */}
        <Card
          style={{
            width: "20%",
            backgroundColor: "#fff",
            borderRadius: "8px",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
            maxHeight: "500px",
            overflowY: "auto",
          }}
        >
          <Skeleton.Input
            active
            style={{
              width: "180px",
              height: "24px",
              marginBottom: "10px",
            }}
          />
          <Skeleton
            active
            paragraph={{
              rows: 6,
              width: ["100%", "90%", "80%", "70%", "60%", "50%"],
            }}
          />
        </Card>
      </div>
    </div>
  );
};

export default SkeletonLoader;
